module.exports = __webpack_public_path__ + "img/mysterious-vessel.f974ecb3.jpg";